var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "w-full" },
    [
      _c(
        "div",
        { staticClass: "h-full w-full" },
        [
          _vm.timeTrackerOpen
            ? _c("TimesheetTimeTrackerModal", {
                attrs: {
                  currentUser: _vm.currentUser,
                  activeActivity: _vm.activeActivity,
                  canPause: _vm.canPause,
                  activeTimeEntry: _vm.activeTimeEntry,
                  propDate: _vm.trackedDate,
                  propRangeStart: _vm.timerStart,
                  propRangeEnd: _vm.timerEnd,
                  currentCellTime: _vm.currentCellTime,
                  checkDateWeekDisable: _vm.checkDateWeekDisable,
                  companId: _vm.company[0]?.id,
                  timesheetId: _vm.timeSheetId,
                },
                on: {
                  close: function ($event) {
                    return _vm.closeTimeTrackerModal()
                  },
                },
              })
            : _vm._e(),
          _vm.timeTrackerOpenManual
            ? _c("TimesheetTimeTrackerModalManual", {
                attrs: {
                  currentUser: _vm.currentUser,
                  activeActivity: _vm.activeActivity,
                  canPause: _vm.canPause,
                  activeTimeEntry: _vm.activeTimeEntry,
                  propDate: _vm.trackedDate,
                  propRangeStart: _vm.timerStart,
                  propRangeEnd: _vm.timerEnd,
                  currentCellTime: _vm.currentCellTime,
                  checkDateWeekDisable: _vm.checkDateWeekDisable,
                  companId: _vm.company[0]?.id,
                  timesheetId: _vm.timeSheetId,
                },
                on: {
                  close: function ($event) {
                    return _vm.closeTimeTrackerModal(true)
                  },
                },
              })
            : _vm._e(),
          _vm.submitTimeModalOpen
            ? _c("SubmitTimeModal", {
                attrs: {
                  activityTitle: _vm.activeActivity.title,
                  time: _vm.elapsedTime,
                },
                on: { closeSubmitTimeModal: _vm.closeSubmitTimeModal },
                model: {
                  value: _vm.submitTime,
                  callback: function ($$v) {
                    _vm.submitTime = $$v
                  },
                  expression: "submitTime",
                },
              })
            : _vm._e(),
          _vm.rejectReasonModalOpen
            ? _c("RejectReasonModal", {
                attrs: { rejectionReason: _vm.rejectionReason },
                on: {
                  close: function ($event) {
                    _vm.rejectReasonModalOpen = false
                  },
                },
              })
            : _vm._e(),
          !_vm.isTimesheetEmpty
            ? _c("p", { staticClass: "font-outfit text-3xl font-semibold" }, [
                _vm._v("Timesheets"),
              ])
            : _vm._e(),
          _c(
            "LoadingOverlay",
            {
              attrs: {
                loading: _vm.isLoaded,
                hasData: _vm.isTimesheetEmpty,
                customPlaceholderMessage: !_vm.isTimesheetEmpty
                  ? "There are no timesheets"
                  : "Information is currently unavailable",
              },
              scopedSlots: _vm._u([
                {
                  key: "empty_placeholder",
                  fn: function () {
                    return [
                      _c("EmptyListImageProjects", {
                        staticClass: "emptyStyle",
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-row gap-5 items-center justify-between font-medium mb-6",
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex flex-row items-center gap-4" },
                    [
                      _c(
                        "p",
                        { staticClass: "font-outfit text-3xl font-semibold" },
                        [_vm._v("Timesheets")]
                      ),
                      _vm.weekStatus == "SUBMITTED"
                        ? _c("div", { staticClass: "pending" }, [
                            _vm._v(" Pending Approval "),
                          ])
                        : _vm._e(),
                      _vm.weekStatus == "APPROVED"
                        ? _c("div", { staticClass: "approved" }, [
                            _vm._v("Approved"),
                          ])
                        : _vm._e(),
                      _vm.weekStatus == "REJECTED"
                        ? _c(
                            "div",
                            { staticClass: "rejected flex flex-row gap-2" },
                            [
                              _c("div", [_vm._v("Rejected")]),
                              _c(
                                "TooltipNewClick",
                                {
                                  attrs: {
                                    TooltipBoxStyle: "tooltipResources",
                                    tooltipClasses: "rejected_button_Styles",
                                    TooltipStyle: "timesheet_rejection_model",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "content",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex flex-col bg-white",
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "actionLink p-2",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openRejectionReason()
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" Rejection reason ")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    4038945021
                                  ),
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "flex justify-center items-center h-full",
                                    },
                                    [
                                      _c("ExpandDownArrow", {
                                        staticClass:
                                          "h-4 w-4 ml-1 cursor-pointer flex-shrink-0 focus:outline-none",
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "w-96 flex flex-row gap-3 justify-end" },
                    [
                      _c("UiButton", {
                        attrs: {
                          buttonClasses: "my-1 submit_time_contractor_btn",
                          buttonText:
                            _vm.weekStatus === "REJECTED"
                              ? "Resubmit Hours"
                              : "Submit Hours",
                          disabled:
                            !_vm.projectActivityTimes.length ||
                            _vm.weekDisable ||
                            !_vm.totalTimePerWeek,
                          variant: "outline",
                        },
                        on: { click: _vm.submitHours },
                        scopedSlots: _vm._u([
                          {
                            key: "icon",
                            fn: function () {
                              return [
                                _c("CheckmarkBlack", {
                                  staticClass: "w-4 h-4",
                                }),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "hover-icon",
                            fn: function () {
                              return [
                                _c("CheckmarkBlack", {
                                  staticClass: "w-4 h-4",
                                }),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "disabled",
                            fn: function () {
                              return [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "16",
                                      height: "16",
                                      viewBox: "0 0 16 16",
                                      fill: "none",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M13.3337 4L6.00033 11.3333L2.66699 8",
                                        stroke: "#717986",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                      _c("UiButton", {
                        attrs: {
                          buttonClasses: "my-1 log_time_contractor_btn",
                          buttonText: "Log Time",
                          variant: "black",
                          disabled:
                            _vm.weekStatus === "APPROVED" ||
                            _vm.active_company.length === 0 ||
                            _vm.weekStatus === "SUBMITTED",
                        },
                        on: { click: _vm.openTimeTrackerModal },
                        scopedSlots: _vm._u([
                          {
                            key: "icon",
                            fn: function () {
                              return [
                                _c("ClockIcon", { staticClass: "w-4 h-4" }),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "hover-icon",
                            fn: function () {
                              return [
                                _c("ClockIconBlack", {
                                  staticClass: "w-4 h-4",
                                }),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "disabled",
                            fn: function () {
                              return [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "16",
                                      height: "16",
                                      viewBox: "0 0 16 16",
                                      fill: "none",
                                    },
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          "clip-path": "url(#clip0_1989_5285)",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0ZM7.25 3.75V8C7.25 8.25 7.375 8.48438 7.58437 8.625L10.5844 10.625C10.9281 10.8562 11.3938 10.7625 11.625 10.4156C11.8562 10.0687 11.7625 9.60625 11.4156 9.375L8.75 7.6V3.75C8.75 3.33437 8.41562 3 8 3C7.58437 3 7.25 3.33437 7.25 3.75Z",
                                            fill: "#717986",
                                          },
                                        }),
                                      ]
                                    ),
                                    _c("defs", [
                                      _c(
                                        "clipPath",
                                        { attrs: { id: "clip0_1989_5285" } },
                                        [
                                          _c("rect", {
                                            attrs: {
                                              width: "16",
                                              height: "16",
                                              fill: "white",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "flex flex-row justify-between pb-8 mt-1" },
                [
                  _c(
                    "div",
                    {},
                    [
                      _c("MultiSelectComponent", {
                        attrs: {
                          withoutLoading: "",
                          placeholder: "Select company",
                          disabled: _vm.active_companies?.length === 0,
                          value: _vm.active_company,
                          options: _vm.active_companies,
                          getcontainerStyle: "customWidthInputTimehseet",
                        },
                        on: { input: _vm.setCompany },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "h-auto",
                  class: _vm.weekDisable
                    ? ` p-5 timesheet_container timesheet_disable`
                    : ` p-5 timesheet_container`,
                },
                [
                  _c("Tabs", {
                    attrs: {
                      tabs: _vm.tabs,
                      activeTab: _vm.activeTabIndex,
                      tabClasses: "timesheets_tabs",
                    },
                    on: {
                      "update:activeTab": [
                        function ($event) {
                          _vm.activeTabIndex = $event
                        },
                        _vm.changeActiveTab,
                      ],
                      "update:active-tab": function ($event) {
                        _vm.activeTabIndex = $event
                      },
                    },
                    model: {
                      value: _vm.activeTabIndex,
                      callback: function ($$v) {
                        _vm.activeTabIndex = $$v
                      },
                      expression: "activeTabIndex",
                    },
                  }),
                  _vm.activeTabIndex === 0
                    ? _c(
                        "div",
                        [
                          _vm.showDiscalimer
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "mb-8 flex warningText flex-row justify-between w-full",
                                },
                                [
                                  _c("div", { staticClass: "flex flex-row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "mt-1 h-4 w-auto",
                                        attrs: { alt: "delete notes" },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "16",
                                              height: "16",
                                              viewBox: "0 0 16 16",
                                              fill: "none",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                            },
                                          },
                                          [
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  id: "Icon / InfoCircleFilled",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    id: "Vector",
                                                    d: "M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM8.5 11.375C8.5 11.4438 8.44375 11.5 8.375 11.5H7.625C7.55625 11.5 7.5 11.4438 7.5 11.375V7.125C7.5 7.05625 7.55625 7 7.625 7H8.375C8.44375 7 8.5 7.05625 8.5 7.125V11.375ZM8 6C7.80374 5.99599 7.61687 5.91522 7.47948 5.775C7.3421 5.63478 7.26515 5.4463 7.26515 5.25C7.26515 5.0537 7.3421 4.86522 7.47948 4.725C7.61687 4.58478 7.80374 4.50401 8 4.5C8.19626 4.50401 8.38313 4.58478 8.52052 4.725C8.6579 4.86522 8.73485 5.0537 8.73485 5.25C8.73485 5.4463 8.6579 5.63478 8.52052 5.775C8.38313 5.91522 8.19626 5.99599 8 6Z",
                                                    fill: "#070823",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("p", { staticClass: "child ml-2" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.weekStatus !== "APPROVED"
                                              ? "To start logging time please select a company"
                                              : "Timesheets that are approved cannot be actioned on. Please contact your Manager if you need further help."
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "cursor-pointer flex items-center justify-center",
                                      on: {
                                        click: function ($event) {
                                          _vm.showDiscalimer = false
                                        },
                                        mouseover: function ($event) {
                                          _vm.isHovered = true
                                        },
                                        mouseout: function ($event) {
                                          _vm.isHovered = false
                                        },
                                      },
                                    },
                                    [
                                      !_vm.isHovered
                                        ? _c("CrossIcon", {
                                            staticClass: "h-3.5 w-3.5",
                                          })
                                        : _vm._e(),
                                      _vm.isHovered
                                        ? _c("CrossIconHover", {
                                            staticClass: "close-icon",
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c("vue-cal", {
                            ref: "vuecalRef",
                            attrs: {
                              events: _vm.events,
                              "time-from": 7 * 60,
                              "time-to": 25 * 60,
                              "time-cell-height": 120,
                              "twelve-hour": true,
                              id: "vuecal",
                              "hide-view-selector": "",
                              "disable-views": [
                                "years",
                                "year",
                                "month",
                                "day",
                              ],
                              "min-event-width": 100,
                              "today-button": "",
                              allDayBarHeight: "50px",
                              editableEvents: _vm.canEdit,
                            },
                            on: {
                              "cell-click": _vm.onCellClick,
                              "event-drag-create": _vm.openTimeTrackerModal,
                              "event-duration-change": _vm.updateTrackedTimes,
                              "event-drop": _vm.updateTrackedTimes,
                              ready: function ($event) {
                                return _vm.getWeek($event)
                              },
                              "view-change": function ($event) {
                                return _vm.getWeek($event)
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "today-button",
                                  fn: function () {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "tota_hours_txt" },
                                        [_vm._v("Total hours tracked: ")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "tota_hours_txt" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.getRanderWeekTotalTime)
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "tota_hours_txt" },
                                        [_vm._v("out of 40h")]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "title",
                                  fn: function ({ view }) {
                                    return [
                                      view.id === "week"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "font-outfit font-semibold text-xl w-full justify-between",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.dateRange(view)) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                                {
                                  key: "weekday-heading",
                                  fn: function ({ heading }) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "font-outfit flex flex-col font-medium text-base h-18",
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(heading.date.format("DD"))
                                            ),
                                          ]),
                                          _c(
                                            "span",
                                            { staticClass: "weekday_name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  heading.label.substring(0, 3)
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "time-cell",
                                  fn: function ({ hours, minutes }) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          class: {
                                            "vuecal__time-cell-line": false,
                                            hours: !minutes,
                                          },
                                        },
                                        [
                                          !minutes
                                            ? _c(
                                                "strong",
                                                {
                                                  staticStyle: {
                                                    "font-size": "15px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        hours % 12 === 0
                                                          ? 12
                                                          : hours % 12
                                                      ) +
                                                      " "
                                                  ),
                                                  hours < 12
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "15px",
                                                          },
                                                        },
                                                        [_vm._v("AM")]
                                                      )
                                                    : _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "15px",
                                                          },
                                                        },
                                                        [_vm._v("PM")]
                                                      ),
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-size": "11px",
                                                  },
                                                },
                                                [_vm._v(_vm._s(minutes))]
                                              ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "cell-content",
                                  fn: function ({ cell, view, events }) {
                                    return [
                                      ["week", "day"].includes(view.id) &&
                                      !events.length
                                        ? _c("span", {
                                            staticClass: "vuecal__no-event",
                                          })
                                        : _vm._e(),
                                    ]
                                  },
                                },
                                {
                                  key: "event",
                                  fn: function ({ event }) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "cursor-pointer w-full h-full timer_cell_parent min-h-4",
                                          on: {
                                            click: function ($event) {
                                              return _vm.openTimeTrackerModal(
                                                event
                                              )
                                            },
                                          },
                                        },
                                        [
                                          event.class !== "TIMER"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "vuecal__event-time flex flex-col items-start font-outfit text-sm ml-2",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        event.start.formatTime(
                                                          "h:mm AM"
                                                        )
                                                      ) +
                                                      " - " +
                                                      _vm._s(
                                                        event.end.formatTime(
                                                          "h:mm AM"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex items-start justify-between font-bold font-outfit ml-2 mr-2 mt-2",
                                                },
                                                [
                                                  _c("span", {
                                                    attrs: { id: "timerLabel" },
                                                  }),
                                                  _c(
                                                    "button",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.stopButton.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "rounded-full hover:bg-white hover:text-black px-2 hover:font-bold",
                                                        },
                                                        [_vm._v(" STOP ")]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "vuecal__event-content flex flex-col items-start font-outfit ml-2 text-base",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex justify-between items-center w-full",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-base font-medium",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(event.content) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c("EditIconVue", {
                                                    staticClass:
                                                      "time_edit_icon mr-1",
                                                  }),
                                                ],
                                                1
                                              ),
                                              event.class !== `TIMER`
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-base font-medium",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          (
                                                            (event.end -
                                                              event.start) /
                                                            1000 /
                                                            60 /
                                                            60
                                                          ).toFixed(0)
                                                        ) + "H"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              event.class === `TIMER`
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-base font-medium rounded-full px-4 border border-white mt-2",
                                                    },
                                                    [_vm._v(" Active Timer ")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3413934056
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.activeTabIndex === 1
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "table-holder bg-white rounded-md md py-4 px-7 font-outfit",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "mb-5 flex warningText flex-row justify-between w-full",
                            },
                            [
                              _c("div", { staticClass: "flex flex-row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "mt-1 h-4 w-auto",
                                    attrs: { alt: "image" },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "16",
                                          height: "16",
                                          viewBox: "0 0 16 16",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              id: "Icon / InfoCircleFilled",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                id: "Vector",
                                                d: "M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM8.5 11.375C8.5 11.4438 8.44375 11.5 8.375 11.5H7.625C7.55625 11.5 7.5 11.4438 7.5 11.375V7.125C7.5 7.05625 7.55625 7 7.625 7H8.375C8.44375 7 8.5 7.05625 8.5 7.125V11.375ZM8 6C7.80374 5.99599 7.61687 5.91522 7.47948 5.775C7.3421 5.63478 7.26515 5.4463 7.26515 5.25C7.26515 5.0537 7.3421 4.86522 7.47948 4.725C7.61687 4.58478 7.80374 4.50401 8 4.5C8.19626 4.50401 8.38313 4.58478 8.52052 4.725C8.6579 4.86522 8.73485 5.0537 8.73485 5.25C8.73485 5.4463 8.6579 5.63478 8.52052 5.775C8.38313 5.91522 8.19626 5.99599 8 6Z",
                                                fill: "#070823",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("p", { staticClass: "child ml-2" }, [
                                  _vm._v(
                                    " The list view lets you easily check your tracked time each week. To log time, just click 'Log time' or switch to the Calendar view. Time you log in the list view shows up right away in the Calendar view and will appear in the List view once your weekly Timesheet has been submitted. "
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                          _c("TabsResource", {
                            attrs: {
                              tabs: _vm.actionTabs,
                              selectedRows: _vm.selectedRows,
                              activeTab: _vm.activeTabIndexRes,
                              tabClasses: "timesheets_tabs",
                            },
                            on: {
                              "update:activeTab": function ($event) {
                                _vm.activeTabIndexRes = $event
                              },
                              "update:active-tab": function ($event) {
                                _vm.activeTabIndexRes = $event
                              },
                              "download-selected": _vm.handleDownloadSelected,
                              "download-all": _vm.downloadAllTimesheetsCSV,
                            },
                            scopedSlots: _vm._u(
                              [
                                _vm._l(_vm.actionTabs, function (tab, index) {
                                  return {
                                    key: `tab-${index}`,
                                    fn: function () {
                                      return [
                                        _c("TableView", {
                                          key: index,
                                          attrs: {
                                            columns: _vm.columns,
                                            getBodyRowClasses:
                                              _vm.getBodyRowClasses,
                                            data: _vm.timesheet,
                                            hasActions: false,
                                            loading: _vm.isLoaded,
                                            sort_by: _vm.sortBy,
                                            sort_direction: _vm.sortDirection,
                                          },
                                          on: { sort: _vm.handleSort },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "status",
                                                fn: function ({ row }) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "status",
                                                        class: row.status,
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.status(
                                                              row.status
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "hours",
                                                fn: function ({ row }) {
                                                  return [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.convertSecondsToHoursMinutesSeconds(
                                                            row.tracked_time
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "company",
                                                fn: function ({ row }) {
                                                  return [
                                                    _c("div", [
                                                      row.company
                                                        ? _c("div", [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  row.company
                                                                    .business_name
                                                                )
                                                              ),
                                                            ]),
                                                          ])
                                                        : _vm._e(),
                                                    ]),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "period",
                                                fn: function ({ row }) {
                                                  return [
                                                    _c("div", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.gettimeRangeFormat(
                                                              row.start_date,
                                                              row.end_date
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  }
                                }),
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.activeTabIndexRes,
                              callback: function ($$v) {
                                _vm.activeTabIndexRes = $$v
                              },
                              expression: "activeTabIndexRes",
                            },
                          }),
                          _c("Pagination", {
                            attrs: {
                              limit: _vm.limit,
                              current: _vm.currentPage,
                              total: _vm.totalPages,
                              paginationClasses: "timesheet_table_pagination",
                            },
                            on: {
                              "limit-change": _vm.onLimitChange,
                              "next-page": function ($event) {
                                return _vm.changePage(1)
                              },
                              "prev-page": function ($event) {
                                return _vm.changePage(-1)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm.isNoCompany
        ? _c("AlertModel", {
            attrs: {
              hasIcon: true,
              okBtnText: "Go back",
              actions: { noBtn: false, okBtn: true },
              title: "Select a company",
              text: "To start logging time please select which company you would like to create the timesheet for.",
            },
            on: { input: _vm.closeCompanyModel },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }